import { createTypes, async, asyncActionCreator } from 'redux-action-creator';
import { getAllWaiverConfigurations } from '../../../../service/waiverConfigurationService';
import { ThunkAction } from '../../../types';

export const types: { [key: string]: string } =
  createTypes([...async('LOAD')], 'WAIVER_CONFIGURATIONS');

export const fetchWaiverConfigurations: () => ThunkAction = asyncActionCreator(
  types.LOAD,
  () => getAllWaiverConfigurations()
);
